import type { TApplicationStatus } from '@doutorsim/shared/applications'
import { Status } from '../_components/status'
import { getStatusConfig } from '../_constants/admission-status'
import type { TUserType } from '../_lib/auth-client.types'

export const getAdmissionFormStatusLabel = (status: TApplicationStatus, userType: TUserType) => {
  const config = getStatusConfig(status, userType)
  if (!config) return null

  return (
    <Status className={config.badgeClassName} classNameCircle={config.badgeCircleClassName}>
      {config.label}
    </Status>
  )
}
